import React, { Component } from 'react';
import PageHelmet from '../component/common/Helmet';
import Breadcrumb from '../component/common/Breadcrumb';
import { Accordion, Container, Card, Row, Col } from 'react-bootstrap';
import ScheduleADemoSection from '../component/scheduleADemoSection/ScheduleADemoSection';

class Faqs extends Component {
  render() {
    window.addEventListener('scroll', function () {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector('.header--fixed').classList.add('sticky');
      } else {
        document.querySelector('.header--fixed').classList.remove('sticky');
      }
    });
    return (
      <React.Fragment>
        <PageHelmet
          pageTitle="FAQ - Noctil"
          description="Noctil | A cloud transformation company | Music  Rights | Audio Visual Rights"
        />
        <Breadcrumb title={'FAQ’s'} />
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Accordion>
                <Card>
                  <Accordion.Collapse eventKey="0">
                    <Container>
                      <Card.Body>
                        MatchIQ is an AI platform that Noctil provides for increasing
                        movie & music royalty distributions. It identifies, corrects, and
                        cleans up errors in metadata with the help of techniques like
                        Matching and De-duplication. This reduces manual interventions and
                        increases precision by 98%. The platform updates everything in
                        real-time, assisting organizations in lowering operational costs.
                      </Card.Body>
                    </Container>
                  </Accordion.Collapse>
                  <Accordion.Toggle as={Card.Header} eventKey="0">
                    <Container>
                      <Row>
                        <Col className="col-10 px-3">
                          <div
                            className="d-flex align-items-center"
                            style={{ height: '100%' }}
                          >
                            What is MatchIQ?
                          </div>
                        </Col>
                        <Col
                          className="col-2 align-self-center pl-2 py-2"
                          style={{ textAlign: 'right' }}
                        >
                          <img
                            className="accordion-arrow"
                            src="/assets/images/icons/accordion-down-arrow.svg"
                            width="18"
                            height="18"
                            alt="chevron-right"
                          />
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Toggle>
                </Card>
                <Card>
                  <Accordion.Collapse eventKey="1">
                    <Container>
                      <Card.Body>
                        <div className="service-details-inner">
                          <div className="sercice-details-content">
                            <div className="details">
                              <ul className="liststyle">
                                <li>If you are from Music or Movie industry</li>
                                <li>
                                  And you oversee distribution and the collection
                                  department, membership management, or licensing
                                </li>
                                <li>
                                  An organization that wants to focus on improving its
                                  overall system performance.
                                </li>
                                <li>Or if you belong to the Publishing department</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Container>
                  </Accordion.Collapse>
                  <Accordion.Toggle as={Card.Header} eventKey="1">
                    <Container>
                      <Row>
                        <Col className="col-10 px-3">
                          <div
                            className="d-flex align-items-center"
                            style={{ height: '100%' }}
                          >
                            Who is it useful for?
                          </div>
                        </Col>
                        <Col
                          className="col-2 align-self-center pl-2 py-2"
                          style={{ textAlign: 'right' }}
                        >
                          <img
                            className="accordion-arrow"
                            src="/assets/images/icons/accordion-down-arrow.svg"
                            width="18"
                            height="18"
                            alt="chevron-right"
                          />
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Toggle>
                </Card>
                <Card>
                  <Accordion.Collapse eventKey="2">
                    <Container>
                      <Card.Body>
                        We have taken steps to ensure your organization's data is entirely
                        secure and that we are GDPR compliant.
                      </Card.Body>
                    </Container>
                  </Accordion.Collapse>
                  <Accordion.Toggle as={Card.Header} eventKey="2">
                    <Container>
                      <Row>
                        <Col className="col-10 px-3">
                          <div
                            className="d-flex align-items-center"
                            style={{ height: '100%' }}
                          >
                            Is my organization's data secure?
                          </div>
                        </Col>
                        <Col
                          className="col-2 align-self-center pl-2 py-2"
                          style={{ textAlign: 'right' }}
                        >
                          <img
                            className="accordion-arrow"
                            src="/assets/images/icons/accordion-down-arrow.svg"
                            width="18"
                            height="18"
                            alt="chevron-right"
                          />
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Toggle>
                </Card>
                <Card>
                  <Accordion.Collapse eventKey="3">
                    <Container>
                      <Card.Body>
                        <div className="service-details-inner">
                          <div className="sercice-details-content">
                            <div className="details">
                              <ul className="liststyle">
                                <li>
                                  You can fill up the form by clicking on schedule a demo
                                  button
                                </li>
                                <li>
                                  Once we receive your form, our team will contact you
                                  through email to schedule a quick call
                                </li>
                                <li>
                                  During our call, we will go over your business's
                                  requirements and explain our platform. In case you have
                                  a specific need, we can configure a specific
                                  functionality in the system for you during this call.
                                </li>
                                <li>
                                  Next, a demo call would be set up to give you an
                                  in-depth view of the system
                                </li>
                                <li>
                                  Once you confirm and share the service agreement, you
                                  can start using our service
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Container>
                  </Accordion.Collapse>
                  <Accordion.Toggle as={Card.Header} eventKey="3">
                    <Container>
                      <Row>
                        <Col className="col-10 px-3">
                          <div
                            className="d-flex align-items-center"
                            style={{ height: '100%' }}
                          >
                            How do I get started?
                          </div>
                        </Col>
                        <Col
                          className="col-2 align-self-center pl-2 py-2"
                          style={{ textAlign: 'right' }}
                        >
                          <img
                            className="accordion-arrow"
                            src="/assets/images/icons/accordion-down-arrow.svg"
                            width="18"
                            height="18"
                            alt="chevron-right"
                          />
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Toggle>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>
        <div className="mt--40">
          <ScheduleADemoSection />
        </div>
      </React.Fragment>
    );
  }
}
export default Faqs;
